import React from 'react';
import { createUseStyles } from 'react-jss';

import { theme, type LcpnTheme } from '../../styles/theme';
import { Typography } from '../Typography';

const useStyles = createUseStyles((theme: LcpnTheme) => ({
  table: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.colors.white,
    paddingBottom: theme.spacing(4),
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
  },

  key: {
    width: '100%',
    marginLeft: `clamp(${theme.spacing(17)}, 5.5%, ${theme.spacing(17)})`,
  },

  value: {
    width: '100%',
  },

  [`@media screen and (max-width: ${theme.breakPoints.tablet}px)`]: {
    key: {
      '&&': {
        marginLeft: theme.spacing(2),
      },
    },
  },
}));

type Row = {
  key: string | React.ReactNode;
  value?: string;
  fallback?: string;
};

type Props = {
  rows: Row[];
};

export function ProgrammeSummary(props: Props) {
  const classes = useStyles();
  const { rows } = props;

  return (
    <>
      <dl className={classes.table}>
        {rows
          .filter(c => c.value || c.fallback)
          .map((row, index) => (
            <div className={classes.row} key={index}>
              <dt className={classes.key}>
                {typeof row.key === 'string' ? (
                  <Typography variant="p3" fontWeight={400} preserveReactNodes>
                    {row.key}
                  </Typography>
                ) : (
                  <div
                    style={{
                      fontSize: theme.fontSizes.p3,
                      fontWeight: 400,
                      fontFamily: 'Be Vietnam Pro',
                    }}
                  >
                    {row.key}
                  </div>
                )}
              </dt>
              <dd className={classes.value}>
                <Typography variant="p3" fontWeight={400}>
                  {row.value ?? row.fallback}
                </Typography>
              </dd>
            </div>
          ))}
      </dl>
    </>
  );
}
